// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4283) return "static/chunks/4283.f8035836decc8873.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1359":"10c8b38f94ed1257","6485":"9cb393c22b77e1a9","8331":"7be62ee0e592eca3"}[chunkId] + ".js";
};